export default "__VITE_ASSET__B3R_1mUy__"